export enum KeyboardKey {
  ENTER = 'Enter',
  ESC = 'Escape',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  HOME = 'Home',
  END = 'End',
}

export enum OptionSelect {
  NEXT = 'next',
  PREVIOUS = 'previous',
  LAST = 'last',
  FIRST = 'first',
  UPDATE = 'update',
}
